export const COOKIE_SESSION_TOKEN = '__http_only_cookie_session__';

export function isCookieSessionToken(token: string | null | undefined): boolean {
  return token === COOKIE_SESSION_TOKEN;
}

export function hasSessionToken(token: string | null | undefined): boolean {
  return Boolean(token);
}
